import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import EnvelopeRegular from './envelope-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EnvelopeRegular {...validProps} />;
}
SvgComponent.iconName = 'envelopeRegular';

export const EnvelopeRegularIcon = svgIconWrapper(SvgComponent);
